"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseTermsModal = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _Controls = require("../PromoModal/parts/Controls");
var _ModalLayout = require("./parts/ModalLayout");
var _ContentLayout = require("./parts/ContentLayout/ContentLayout");
var _PurchaseTerm = require("./parts/PurchaseTerm");
var _ErrorScreen = require("./parts/ErrorScreen");
var _Loader = require("./parts/Loader");
var _FullscreenModalLayout = require("../PromoModal/parts/FullscreenModalLayout");
var _usePurchaseTerms = require("./hooks/usePurchaseTerms");
var _trackCollapsedBlockClick = require("./tracking/trackCollapsedBlockClick");
var _Modal = require("./parts/Modal");
var _PromoModal = require("../PromoModal");
var _FullPriceModal = require("../FullPriceModal");
var _PromoControlsWrapper = require("./parts/PromoControlsWrapper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PurchaseTermsModal = props => {
  const {
    offerId,
    controls,
    innerControls,
    open,
    onOpenChange,
    mainPromoId,
    isDiscountPromo,
    config
  } = props;
  const handleClose = React.useCallback(() => onOpenChange(false), [onOpenChange]);
  const {
    error,
    details,
    fetchDetails
  } = (0, _usePurchaseTerms.usePurchaseTerms)({
    offerId,
    mainPromoId,
    isDiscountPromo
  });
  const device = (0, _uiKit.useDeviceType)();
  const [preparedPromo, setPreparedPromo] = React.useState(null);
  const [isFullPriceMethod, setIsFulllPriceMethod] = React.useState(false);
  const isPhone = device === 'phone';
  const showModal = !isPhone && !preparedPromo || isPhone;
  const handlePromoModalClose = React.useCallback(() => {
    setPreparedPromo(null);
    if (!isPhone) {
      onOpenChange(false);
    }
  }, [setPreparedPromo, onOpenChange, isPhone]);
  const handleBackButtonClick = React.useCallback(() => {
    setPreparedPromo(null);
  }, [setPreparedPromo]);
  React.useEffect(() => {
    if (!open) {
      return;
    }
    fetchDetails();
  }, [offerId, fetchDetails, open]);
  const [openedCategoryIndex, setOpenedCategoryIndex] = React.useState(null);
  const handleClick = index => {
    const type = details ? details.details[index].type : '';
    setOpenedCategoryIndex(index);
    (0, _trackCollapsedBlockClick.trackCollapsedBlockClick)(type);
  };
  const handleCollapse = () => {
    setOpenedCategoryIndex(null);
  };
  if (error) {
    return /*#__PURE__*/React.createElement(_Modal.Modal, {
      open: open,
      onClose: handleClose
    }, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      phone: true
    }, /*#__PURE__*/React.createElement(_FullscreenModalLayout.FullscreenModalLayout, {
      onClose: handleClose
    }, /*#__PURE__*/React.createElement(_ErrorScreen.ErrorScreen, {
      onClose: handleClose,
      onRetry: fetchDetails
    }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
      desktop: true,
      tablet: true
    }, /*#__PURE__*/React.createElement(_ErrorScreen.ErrorScreen, {
      onClose: handleClose,
      onRetry: fetchDetails
    })));
  }
  if (!details) {
    return /*#__PURE__*/React.createElement(_Modal.Modal, {
      open: open,
      onClose: handleClose,
      controls: /*#__PURE__*/React.createElement(_uiKit.Button, {
        size: "M",
        loading: true
      }, "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430")
    }, /*#__PURE__*/React.createElement(_Loader.Loader, {
      onClose: handleClose
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, showModal && /*#__PURE__*/React.createElement(_Modal.Modal, {
    open: open,
    onClose: handleClose,
    controls: controls
  }, /*#__PURE__*/React.createElement(_ModalLayout.ModalLayout, null, /*#__PURE__*/React.createElement(_ContentLayout.ContentLayout, {
    onClose: handleClose,
    subtitle: details.subtitle,
    title: details.title
  }, details.details.map((term, index) => /*#__PURE__*/React.createElement(_PurchaseTerm.PurchaseTerm, {
    key: index,
    term: term,
    onClick: () => handleClick(index),
    handleCollapse: handleCollapse,
    collapsed: openedCategoryIndex !== index,
    linkedPromos: details.linkedPromos,
    setPreparedPromo: setPreparedPromo,
    setIsFulllPriceMethod: setIsFulllPriceMethod
  }))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement(_Controls.Controls, {
    fixed: true
  }, controls)))), preparedPromo && !isFullPriceMethod && /*#__PURE__*/React.createElement(_PromoModal.PromoModal, {
    controls: /*#__PURE__*/React.createElement(_PromoControlsWrapper.PromoControlsWrapper, {
      onBackButtonClick: handleBackButtonClick
    }, innerControls ? innerControls : controls),
    onOpenChange: handlePromoModalClose,
    promo: preparedPromo,
    open: true,
    config: config,
    size: "M"
  }), preparedPromo && isFullPriceMethod && /*#__PURE__*/React.createElement(_FullPriceModal.FullPriceModal, {
    open: true,
    onClose: handlePromoModalClose,
    description: preparedPromo.description,
    controls: /*#__PURE__*/React.createElement(_PromoControlsWrapper.PromoControlsWrapper, {
      onBackButtonClick: handleBackButtonClick
    }, innerControls ? innerControls : controls),
    linkedPromosTitle: preparedPromo.linkedPromos?.title,
    linkedPromosSubtitle: preparedPromo.linkedPromos?.subtitle,
    linkedPromos: preparedPromo.linkedPromos?.promos
  }));
};
exports.PurchaseTermsModal = PurchaseTermsModal;